import { render, staticRenderFns } from "./leaderSay.vue?vue&type=template&id=0fa68498&scoped=true"
import script from "./leaderSay.vue?vue&type=script&lang=js"
export * from "./leaderSay.vue?vue&type=script&lang=js"
import style0 from "./leaderSay.vue?vue&type=style&index=0&id=0fa68498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa68498",
  null
  
)

export default component.exports